import { IDS } from '../settings-action-id.constants';
import * as SettingsActions from '../settings.actions';
import * as RequirementsActions from '../requirements/requirements.actions';
import * as AccreditationActions from '../../accreditation.actions';
/**
 * Creates a new FrameworkDetailsController.
 * @class
 */
class FrameworkDetailsController {
    constructor($ngRedux, $state, $scope, $uiRouterGlobals, $filter, Notifier, NavigationActions, AuthService) {
        this.$ngRedux           = $ngRedux;
        this.$state             = $state;
        this.$scope             = $scope;
        this.$uiRouterGlobals   = $uiRouterGlobals;
        this.$filter            = $filter;
        this.Notifier           = Notifier;
        this.NavigationActions  = NavigationActions;
        this.AuthService        = AuthService;
        this.stateName          = this.$state.$current.name;
        this.tabStateName       = this.$state.$current.parent.name;
    }

    $onInit() {
        this.identifier = IDS.accSettings;
        this.unsubscribe = this.$ngRedux.connect(
            state => {
                return {
                    frameworkDetails:  state.accreditation.accSettings.frameworkDetails,
                    title:          state.accreditation.accSettings.frameworkDetails.title,
                }
            }, {
                ...AccreditationActions,
                ...SettingsActions,
                ...RequirementsActions,
            }
        )(this);

        this.frameworkCode = this.$uiRouterGlobals.params.itemCode;
        this.getRegulatoryFrameworkDetails(this.frameworkCode);
    }

    onSubmit() {
        this.$scope.$broadcast('show-errors-check-validity', '$ctrl.detailsForm');
        if (this.detailsForm.$valid) {
            let module_prefixes;
            if(this.frameworkDetails.module_prefixes_text && this.frameworkDetails.module_prefixes_text.replace(/[^a-z0-9]/gi, '').length) {
                module_prefixes = this.frameworkDetails.module_prefixes_text.split(',').map(item => item.replace(/[^a-z0-9]/gi, '')).filter(item => item);
            }
            const data = {
                ...this.frameworkDetails,
                module_prefixes,
                module_prefixes_text: undefined
            }
            this.editRegulatoryFramework(data).then(() => {
                this.$ngRedux.dispatch(this.NavigationActions.getConfigs());
                this.fetchFrameworkRequirementsTree(this.frameworkCode);
            });
        }
        else this.Notifier.error('COMMON.FIELDS_REQUIRED');
    }

    onActivate() {
        this.activateScheme(this.frameworkDetails.id).then(()=>{
            this.getSchemeStatus(this.frameworkDetails.id);
        });
    }

    onDeactivate() {
        this.deactivateScheme(this.frameworkDetails.id).then(()=>{
            this.getSchemeStatus(this.frameworkDetails.id);
        });
    }

    $onDestroy() {
        this.unsubscribe();
    }
}

FrameworkDetailsController.$inject = ['$ngRedux', '$state', '$scope', '$uiRouterGlobals', '$filter', 'Notifier', 'NavigationActions', 'AuthService']

export const frameworkDetails = {
    controller: FrameworkDetailsController,
    template: require('./framework-details.html')
}
